import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  notificationMessage!: string;
  showSuccessToaster: boolean = false;
  showErrorToaster: boolean = false;
  showInfoToaster: boolean = false;
  showWarnToaster: boolean = false;
  isToasterVisible: boolean = false;
  
  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.currentMessage.subscribe((message: any) => {
      this.notificationMessage = message.msg;
      this.isToasterVisible = true;
      if (message.type == 'success') {
        this.showSuccessToaster = true;
        setTimeout(() => this.showSuccessToaster = false, 5001)
      } else if (message.type == 'info') {
        this.showInfoToaster = true;
        setTimeout(() => this.showInfoToaster = false, 5001)
      } else if (message.type == 'warn') {
        this.showWarnToaster = true;
        setTimeout(() => this.showWarnToaster = false, 5001)
      } else {
        this.showErrorToaster = true;
        setTimeout(() => this.showErrorToaster = false, 5001);
      }
      setTimeout(() => this.isToasterVisible = false, 5001);
    })
  }
  
  hideToaster($event: any){
    if($event.detail.closed){
      this.isToasterVisible = false
    }
  }

}
